import { HttpContextToken } from '@angular/common/http';

/**
 * Opt a request out of the 401 recovery in TokenInterceptor.
 *
 * Use it when a 401 is a meaningful answer that the caller wants to see, rather
 * than an expired token to be renewed behind its back.
 */
export const SKIP_AUTH_RECOVERY = new HttpContextToken<boolean>(() => false);

/**
 * Set by the interceptor on a request it has already retried once with a fresh
 * token. Prevents an endless refresh/retry loop when the API keeps answering
 * 401 for a reason that renewing the token cannot fix.
 */
export const AUTH_RECOVERY_RETRIED = new HttpContextToken<boolean>(() => false);
